module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.user) ? _c('nav', {
    staticClass: "partial-header navbar navbar-default navbar-fixed-top"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('button', {
    staticClass: "hidden-md hidden-lg btn btn-sm btn-default pull-right",
    staticStyle: {
      "margin-top": "9px"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDrawer()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })]), _vm._v(" "), _c('div', {
    staticClass: "navbar-header"
  }, [_c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('img', {
    staticClass: "ls",
    attrs: {
      "src": _vm.imageUrl('ls.png', '50x50'),
      "alt": "Loca.Shop"
    }
  }), _vm._v(" "), (_vm.user.company && _vm.user.company.image) ? _c('img', {
    attrs: {
      "src": _vm.user.company.image,
      "alt": _vm.user.company.fantasy_name
    }
  }) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "hidden-xs hidden-sm"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [(_vm.user.company.status) ? [_c('li', {
    staticClass: "dropdown",
    class: {
      'active': _vm.routeName.startsWith('home')
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      },
      "title": "Home"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-lg fa-home"
  })])], 1), _vm._v(" "), _c('registrations-menu'), _vm._v(" "), _c('li', {
    staticClass: "dropdown",
    class: {
      'active': _vm.routeName.startsWith('mktp_')
    }
  }, [_c('router-link', {
    staticClass: "dropdown-toggle",
    attrs: {
      "to": {
        name: 'mktp_home'
      },
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n              Pedidos"), (_vm.notificationsPanel && _vm.notificationsPanel.mktp_rents > 0) ? _c('span', {
    staticClass: "bell-badge"
  }, [_vm._v(_vm._s(_vm.notificationsPanel.mktp_rents))]) : _vm._e()])], 1), _vm._v(" "), _c('li', {
    staticClass: "dropdown",
    class: {
      'active': _vm.routeName.startsWith('products_')
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'products_list'
      }
    }
  }, [_vm._v("Produtos")])], 1), _vm._v(" "), ([1].includes(_vm.user.company.id)) ? _c('li', {
    staticClass: "dropdown",
    class: {
      'active': _vm.routeName.startsWith('rents_')
    }
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'rents_add'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-btn fa-plus"
  }), _vm._v(" Cadastrar")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'rents_list'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-btn fa-search"
  }), _vm._v(" Pesquisar")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'rents_dashboard',
        params: {
          statusId: 1
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-btn fa-bell"
  }), _vm._v(" Painel operacional")])], 1)])]) : _vm._e(), _vm._v(" "), ([2, 3, 6, 182].includes(_vm.user.company.id)) ? _c('rent-pre-registrations-menu') : _vm._e(), _vm._v(" "), _c('general-notifications'), _vm._v(" "), ([2, 3, 6, 182].includes(_vm.user.company.id)) ? _c('chat-menu') : _vm._e(), _vm._v(" "), _c('clients-photos-menu')] : _vm._e()], 2), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [(_vm.user.company.status) ? _c('router-link', {
    staticClass: "btn btn-sm btn-success navbar-btn pull-left",
    attrs: {
      "to": {
        name: 'clients_add',
        params: {
          statusId: 1,
          modalVideo: true
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Novo cadastro")]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v("  ")]), _vm._v(" "), (_vm.isCompanyAdmin()) ? _c('router-link', {
    staticClass: "btn btn-sm btn-info navbar-btn pull-left",
    attrs: {
      "to": {
        name: 'finances_dashboard',
        query: {
          buy_credit: 1
        }
      }
    }
  }, [_vm._v("Comprar crédito")]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v("  ")]), _vm._v(" "), _c('li', {
    staticClass: "dropdown"
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "dropdown-header"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-btn fa-user"
  }), _vm._v(_vm._s(_vm.user.name))]), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), (_vm.isCompanyAdmin()) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'company_details'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-btn fa-building"
  }), _vm._v(" Locadora")])], 1) : _vm._e(), _vm._v(" "), (_vm.isCompanyAdmin()) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'employees'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-btn fa-users"
  }), _vm._v(" Usuários")])], 1) : _vm._e(), _vm._v(" "), (_vm.isCompanyAdmin()) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'shipping'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-btn fa-truck"
  }), _vm._v(" Configurações de Frete")])], 1) : _vm._e(), _vm._v(" "), (_vm.isCompanyAdmin()) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'finances_dashboard'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-btn fa-dollar"
  }), _vm._v(" Financeiro")])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.locashopURL + 'termos-de-uso',
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-btn fa-address-book"
  }), _vm._v(" Termos de uso ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.locashopURL + 'politicas-de-privacidade',
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-btn fa-id-badge"
  }), _vm._v(" Política de privacidade ")])]), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.handleLogout()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-btn fa-sign-out"
  }), _vm._v(" Sair")])])])])], 1)])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("Locações "), _c('span', {
    staticClass: "caret"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-bars"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-72f9a912!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/partials/PartialHeader.vue
// module id = 837
// module chunks = 2